module.exports = __webpack_public_path__ + "img/indexlogo.ccae9644.png";